// Drawer: right-side sheet for quick create / edit forms (Add Batch, New client, Edit client). DESIGN §2/§4.
// Same dialog rules as Modal (useDialog): Esc / ✕ close (asking first when the form is dirty), a stray backdrop
// click never discards typed input, focus is trapped. Full-width sheet below 768px.
// Open one with openDrawer((close) => <Drawer title="Add Batch" onClose={close} …>…</Drawer>) — same stack as openModal.
import './drawer.css';
import { useId } from 'preact/hooks';
import { IconButton, cx, openModal, useDialog } from './ui.jsx';

export const openDrawer = openModal;

// onSubmit makes the sheet a <form> (Enter submits). footer: buttons (Cancel · primary action on the right).
export function Drawer({ title, subtitle, onClose, footer, onSubmit, width = 420, class: cls, children }) {
  const { dialogRef, trapTab, backdropProps, markDirty, requestClose, discardBar } = useDialog(onClose);
  const titleId = useId();
  const Tag = onSubmit ? 'form' : 'div';
  const submit = onSubmit ? (e) => { e.preventDefault(); onSubmit(e); } : undefined;
  return (
    <div class="drawer-backdrop" {...backdropProps}>
      <Tag
        ref={dialogRef}
        class={cx('drawer', cls)}
        style={{ '--drawer-w': `${width}px` }}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onKeyDown={trapTab}
        onInput={markDirty}
        onChange={markDirty}
        onSubmit={submit}
        noValidate={onSubmit ? true : undefined}
      >
        <div class="drawer-header">
          <div class="drawer-heading">
            <h2 class="drawer-title" id={titleId}>{title}</h2>
            {subtitle && <p class="meta">{subtitle}</p>}
          </div>
          {onClose && <IconButton icon="x" label="Close" size="sm" onClick={requestClose} />}
        </div>
        <div class="drawer-body">{children}</div>
        {discardBar}
        {footer && <div class="drawer-footer">{footer}</div>}
      </Tag>
    </div>
  );
}
